<div class="nl-page">

  <!-- ===== LEFT PANEL ===== -->
  <div class="nl-left d-none d-lg-flex">
    <div class="nl-left-inner">
      <img src="../../../assets/img/bharat-logo.png" alt="Bharat Logo" class="nl-logo" routerLink="/landingPage" />
      <h1 class="nl-brand">Bharat BoudhIKS</h1>
      <p class="nl-tagline">Where Tradition Meets Transformation</p>

      <div class="nl-stats">
        <div class="nl-stat">
          <span class="nl-stat-num">10K+</span>
          <span class="nl-stat-lbl">Students</span>
        </div>
        <div class="nl-stat-sep"></div>
        <div class="nl-stat">
          <span class="nl-stat-num">200+</span>
          <span class="nl-stat-lbl">Courses</span>
        </div>
        <div class="nl-stat-sep"></div>
        <div class="nl-stat">
          <span class="nl-stat-num">50+</span>
          <span class="nl-stat-lbl">Departments</span>
        </div>
      </div>

      <div class="nl-left-footer">
        <span>© 2025 Bharat BoudhIKS</span>
      </div>
    </div>
  </div>

  <!-- ===== RIGHT PANEL ===== -->
  <div class="nl-right">

    <!-- Back button -->
    <!-- <button class="nl-back-btn" (click)="goBack()" title="Back to Home">
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="16" height="16">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
      </svg>
      Back to Home
    </button> -->

    <div class="nl-form-wrap">

      <!-- Mobile logo -->
      <div class="text-center d-lg-none mb-4">
        <img src="../../../assets/img/bharat-logo.png" alt="Logo" class="nl-mobile-logo" />
        <p class="nl-mobile-brand">Bharat BoudhIKS</p>
      </div>

      <!-- Card -->
      <div class="nl-card">

        <!-- Card header -->
        <div class="nl-card-head">
          <div class="nl-avatar">
            <i class="bi bi-person-fill"></i>
          </div>
          <h2 class="nl-card-title">Welcome Back</h2>
          <p class="nl-card-sub">Sign in to your account to continue</p>
        </div>

        <!-- Form -->
        <form class="nl-form" [formGroup]="loginForm" (keydown.enter)="registerUser()">

          <!-- Email -->
          <div class="nl-field">
            <label class="nl-label" for="nlEmail">
              <i class="bi bi-envelope"></i> Email Address
            </label>
            <input type="email" id="nlEmail" class="nl-input" placeholder="Enter your email" formControlName="userName"
              onkeypress="return !(event.charCode === 32 || this.selectionStart === 0)" />
          </div>

          <!-- Password -->
          <div class="nl-field">
            <label class="nl-label" for="nlPassword">
              <i class="bi bi-lock"></i> Password
            </label>
            <div class="nl-pw-wrap">
              <input id="nlPassword" class="nl-input" placeholder="Enter your password" formControlName="password"
                [type]="fieldTextType ? 'text' : 'password'" />
              <button type="button" class="nl-eye" (click)="toggleFieldTextType()" tabindex="-1">
                <i class="fas" [ngClass]="{'fa-eye-slash': !fieldTextType, 'fa-eye': fieldTextType}"></i>
              </button>
            </div>
          </div>

          <!-- Auth Code (2FA) -->
          <div class="nl-field" *ngIf="showAuthCode">
            <label class="nl-label">
              <i class="bi bi-shield-lock"></i> Auth Code
            </label>
            <input type="text" class="nl-input" placeholder="Enter your auth code" formControlName="login_autogen_code"
              onkeypress="return !(event.charCode === 32 || this.selectionStart === 0)" />
          </div>

          <!-- Remember + Forgot -->
          <div class="nl-row-between">
            <label class="nl-remember">
              <input type="checkbox" id="rememberMe" /> Remember me
            </label>
            <a class="nl-forgot" data-bs-toggle="modal" data-bs-target="#exampleModal">Forgot password?</a>
          </div>

          <!-- Submit -->
          <button type="button" class="nl-submit" (click)="registerUser()">
            <i class="bi bi-box-arrow-in-right me-2"></i> Sign In
          </button>

        </form>

        <!-- Footer links -->
        <div class="nl-card-footer">
          <a class="nl-link" (click)="gotoSchoolRegister()">
            <i class="bi bi-building me-1"></i> Institution Registration
          </a>
          <span class="nl-footer-help">
            Need help? <a class="nl-link" href="#">Contact Support</a>
          </span>
        </div>

      </div>
      <!-- /Card -->

    </div>
  </div>
  <!-- /Right -->

</div>

<!-- ===== FORGOT PASSWORD MODAL ===== -->
<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content nl-modal">
      <div class="modal-header nl-modal-head">
        <div class="d-flex align-items-center gap-2">
          <div class="nl-modal-icon"><i class="bi bi-shield-lock-fill"></i></div>
          <h5 class="modal-title mb-0">Reset Password</h5>
        </div>
        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"
          (click)="close()"></button>
      </div>
      <div class="modal-body px-4 pt-3 pb-2">
        <p class="nl-modal-desc">Enter your registered email and we'll send you a reset link.</p>
        <label class="nl-label mb-1">Email Address</label>
        <div class="input-group">
          <span class="input-group-text nl-ig-icon"><i class="bi bi-envelope"></i></span>
          <input type="email" class="form-control nl-modal-input" placeholder="you@example.com"
            (blur)="validateEmail($event)" [(ngModel)]="emailId" [ngModelOptions]="{standalone: true}" />
        </div>
      </div>
      <div class="modal-footer border-0 px-4 pb-4 gap-2">
        <button type="button" class="btn nl-modal-cancel" id="md_close" (click)="close()"
          data-bs-dismiss="modal">Cancel</button>
        <button type="button" class="btn nl-modal-submit" (click)="onForgotPasswordClick()">
          <i class="bi bi-send me-1"></i> Send Reset Link
        </button>
      </div>
    </div>
  </div>
</div>